import React from 'react';
import { Field, InfoLabel, Input, type LabelProps } from '@fluentui/react-components';

export const DEFAULT_APPEND_ONLY_OVERLAP_SECONDS = 30;
export const DEFAULT_RECONCILE_OVERLAP_SECONDS = 300;
export const MAX_OVERLAP_SECONDS = 86400;

interface IncrementalOverlapFieldProps {
  value?: number;
  defaultSeconds?: number;
  disabled?: boolean;
  hint?: string;
  onChange: (seconds: number) => void;
}

export const IncrementalOverlapField: React.FC<IncrementalOverlapFieldProps> = ({
  value, defaultSeconds = DEFAULT_APPEND_ONLY_OVERLAP_SECONDS, disabled, hint, onChange,
}) => (
  <Field label={{ children: (_: unknown, props: LabelProps) => (
    <InfoLabel {...props} infoButton={{ 'aria-label': 'About the look-back window' }}
      info="Recheck this many seconds before the last successful sync point to capture records that became available late. Records arriving later than this window require a new full snapshot.">
      Look-back window (seconds)
    </InfoLabel>
  ) }} hint={hint ?? `Default: ${defaultSeconds} seconds. Allowed: 0–${MAX_OVERLAP_SECONDS} seconds (up to 1 day).`}>
    <Input type="number" min={0} max={MAX_OVERLAP_SECONDS} step={1} disabled={disabled}
      value={String(value ?? defaultSeconds)} onChange={(_, data) => {
        const seconds = data.value === '' ? defaultSeconds : Number(data.value);
        if (Number.isInteger(seconds) && seconds >= 0 && seconds <= MAX_OVERLAP_SECONDS) {
          onChange(seconds);
        }
      }} />
  </Field>
);